'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./AlbumsItemsGroupWrapper.scss');

var AlbumsItemsGroupWrapper = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(AlbumsItemsGroupWrapper, _PureComponent);

  function AlbumsItemsGroupWrapper() {
    (0, _classCallCheck3.default)(this, AlbumsItemsGroupWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumsItemsGroupWrapper.__proto__ || (0, _getPrototypeOf2.default)(AlbumsItemsGroupWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumsItemsGroupWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showTitles = _props.showTitles,
          title = _props.title,
          children = _props.children;


      if (showTitles) {
        return _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: (0, _bind2.default)('col-xs-60', styles.title) },
            title
          ),
          _react2.default.createElement(
            'div',
            null,
            children
          )
        );
      }

      return _react2.default.createElement(
        'span',
        null,
        children
      );
    }
  }]);
  return AlbumsItemsGroupWrapper;
}(_react.PureComponent), _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
  showTitles: _propTypes2.default.bool,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
}, _temp);
exports.default = AlbumsItemsGroupWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumsItems/AlbumsItemsGroupWrapper/AlbumsItemsGroupWrapper.js
// module id = 1949
// module chunks = 1